import { useState } from "react";
import { Modal } from "react-bootstrap";
import { unlinkUserMobileAccount } from "../../api/manage-app";
import AlertBox from "../AlertBox";
import moment from "moment";

export function ModalUnlinkUserMobile({ show, onClose, onSuccess, selected }) {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) {
      setAlert({ show: false, message: "", type: "" });
      onClose();
    }
  };

  const onUnlink = async () => {
    setLoading(true);
    try {
      const response = await unlinkUserMobileAccount(selected.id);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        message = error.response.data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Unlink Pengguna MyViberlink</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <h5 className="text-gray-800">
          Apakah anda yakin akan unlink pengguna <strong>{selected.fname || "-"}</strong> dengan
          nomor registrasi utama <strong>{selected.registration_number || "-"}</strong>?
        </h5>

        <h6 className="mt-4">Registrasi Lain yang Terhubung</h6>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>No. Reg</th>
              <th>Tanggal Terhubung</th>
            </tr>
          </thead>
          <tbody>
            {selected.others_account?.length ? (
              selected.others_account.map((other) => (
                <tr key={other.id}>
                  <td>{other.registration_number || "-"}</td>
                  <td>
                    {other.createdAt ? moment.unix(other.createdAt).format("DD MMM YYYY") : "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>Tidak ada registrasi lain</td>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={() => handleClose()} disabled={loading}>
          Tidak
        </button>
        <button className="btn btn-danger" onClick={() => onUnlink()} disabled={loading}>
          {loading ? "Menunggu ..." : "Ya, Unlink"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
